import { EyeOffRegular } from "@fluentui/react-icons";
import { Tooltip, Button } from "@fluentui/react-components";
import React from "react";
import * as Constants from "../../utils/constants";
import { IAppSettings, IUser } from "../../types/types";

interface IWeektableHideCellProps {
    projectId: string;
    disHasHours: boolean;
    projectName: string;
    jwtoken: string;
    user: IUser;
    visibleProjects: string[] | undefined;
    setVisibleProjects: (projects: string[]) => void;
    update: () => void;
    updateUserAppSettings: (jwtoken: string, appSettings: IAppSettings) => Promise<IUser>;
}

export default function WeektableHideCell(props: IWeektableHideCellProps) {
    // Never render hide control for the default hours project
    if (props.projectId === Constants.DEFAULT_PROJECT_ID) {
        return null;
    }

    const isDisabled = props.disHasHours;

    // Utility function to remove objects from an array
    const removeObjectsFromArray = (arr: any[]) => {
        return arr.filter((item) => typeof item !== "object");
    };

    // Handle hide event for the project
    const handleHide = (projectId: string, hasHours: boolean) => async () => {
        try {
            if (hasHours || projectId === Constants.DEFAULT_PROJECT_ID) {
                console.warn("Cannot hide project");
                return;
            }

            if (props.visibleProjects) {
                const currArr = removeObjectsFromArray([...props.visibleProjects]);

                const index = currArr.indexOf(projectId);
                if (index !== -1) {
                    currArr.splice(index, 1);
                }

                const appSettings = props.user?.app_settings;
                if (appSettings) {
                    appSettings.visible_projects = currArr;
                    const user = await props.updateUserAppSettings(props.jwtoken, appSettings);
                    props.setVisibleProjects(user.app_settings.visible_projects);
                    props.update();
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const tooltip = props.disHasHours ? (
        <div>
            <div>Hours applied,</div>
            <div>cannot hide this week</div>
        </div>
    ) : (
        `Hide project: ${props.projectName}`
    );

    return (
        <div>
            <div className="flex gap-2">
                <Tooltip content={tooltip} relationship="label">
                    <Button
                        appearance="transparent"
                        icon={
                            <EyeOffRegular
                                className={
                                    isDisabled
                                        ? "text-gray-400 dark:text-gray-600"
                                        : "text-red-600 dark:text-red-400"
                                }
                            />
                        }
                        disabled={isDisabled}
                        onClick={handleHide(props.projectId, props.disHasHours)}
                    />
                </Tooltip>
            </div>
        </div>
    );
}
